/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "@/src/theme/commonStyle";

const settlementTimeSectionStyle = {
  timeSection: {
    textAlign: "center",
  },
  headline: {
    color: "primary.main",
  },
  subHeadline: {
    paddingTop: "1rem",
    color: "primary.main",
  },
  scrollToAnchor,
};

export default settlementTimeSectionStyle;
